
import { computed, onMounted, ref } from 'vue'
import { getInfoPermissionFromUser } from './commonUtil'
import * as service from '../service'
import { debounce } from '@/utils/common'
import { getOfficialTag } from '@/services/songs'
import { getTeacherTags } from '@/services/common'
import { SearchOutlined } from '@ant-design/icons-vue'
import SelectBookModal from '@/views/songs/components/SelectBookModal.vue'

export default {
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  components: {
    SearchOutlined,
    SelectBookModal
  },
  setup (props, { emit }) {
    const visibleValue = computed(() => props.visible)
    // tab列的key值
    const tabKey = getInfoPermissionFromUser()
    // computed属性的tabkey值的集合
    const tabSet = computed(() => new Set(tabKey))

    const currentTabKey = ref(tabKey[0] || null)

    // 列表数据
    const dataList = ref([])
    const handleCancel = () => {
      emit('onCancel')
    }
    let currentPage = 1
    // 页面变动
    const handlePageChange = (page) => {
      currentPage = page
      handleSearch()
    }
    const paginations = ref({ current: currentPage, pageSize: 10, onChange: handlePageChange })
    const loading = ref(false)

    const bookModalVisible = ref(false)
    const bookModalRef = ref()
    const bookShowName = ref('教材名称-章节目录')

    const handleBookSelectOk = (value) => {
      bookShowName.value = value.labels.join('-')
      formData.value.book_id = value.values[0]
      formData.value.book_section_id = value.values[1]
      bookModalVisible.value = false
      currentPage = 1
    }

    const handleShowBookModal = () => {
      bookModalVisible.value = true
    }

    const formData = ref({
      name: undefined,
      song_code: undefined,
      type: undefined,
      book_id: undefined,
      tag: []
    })

    const tagOpts = ref([])

    const getTagSearch = debounce(async (value) => {
      let SearchFunc = null
      if (currentTabKey.value === 'official') {
        SearchFunc = getOfficialTag
      } else if (currentTabKey.value === 'personal') {
        SearchFunc = getTeacherTags
      }
      if (SearchFunc !== null) {
        const tagList = await SearchFunc({ keyword: value, current: 1, per_page: 20 })
        tagOpts.value = tagList.items.map(item => { return { label: item.tag, value: item.tag } })
      }
    })

    const queryOfficialList = async (params) => {
      try {
        loading.value = true
        const data = await service.getOfficialEnjoySong({
          ...params,
          per_page: paginations.value.pageSize,
          page: currentPage,
          except_statuses: [2]
        })
        paginations.value = { ...paginations.value, ...data.meta, pageSize: +data.meta.per_page, current: data.meta.current_page }
        dataList.value = data.items
        loading.value = false
      } catch (error) {
        loading.value = false
        console.log(error)
        throw error
      }
    }

    const queryTeacherList = async (params) => {
      try {
        loading.value = true
        const data = await service.getTeacherEnjoySong({
          ...params,
          except_statuses: 2,
          per_page: paginations.value.pageSize,
          page: currentPage
        })
        paginations.value = { ...paginations.value, ...data.meta, pageSize: +data.meta.per_page, current: data.meta.current_page }
        dataList.value = data.items
        loading.value = false
      } catch (error) {
        loading.value = false
        console.log(error)
        throw error
      }
    }

    const handleSearchBtnClick = async () => {
      currentPage = 1
      await handleSearch()
    }

    const handleSearch = async () => {
      let searchFunc = null
      if (currentTabKey.value === 'official') {
        searchFunc = queryOfficialList
      } else if (currentTabKey.value === 'personal') {
        searchFunc = queryTeacherList
      }

      if (searchFunc !== null) {
        const params = formData.value
        await searchFunc(params)
      }
    }

    const handleResetForm = () => {
      formData.value = {
        name: undefined,
        song_code: undefined,
        type: undefined,
        tag: [],
        book_id: undefined,
        book_section_id: undefined
      }
      bookShowName.value = '教材名称-章节目录'
      getTagSearch('')
      currentPage = 1
      bookModalRef.value.handleReset()
      handleSearch()
    }

    const handleAddSong = (record) => {
      emit('onOk', { sid: record.id, source: currentTabKey.value })
      emit('onCancel')
    }

    onMounted(async () => {
      getTagSearch('')
      handleSearch()
    })

    const cloumns = [
      {
        title: '歌曲名称',
        dataIndex: 'name',
        key: 'name',
        ellipsis: true,
        width: 80
      },
      {
        title: '歌曲编码',
        dataIndex: 'song_code',
        key: 'song_code',
        width: 80,
        ellipsis: true
      },
      {
        title: '歌曲简拼',
        dataIndex: 'py',
        key: 'py',
        ellipsis: true,
        width: 50
      },
      {
        title: '标签',
        dataIndex: 'tags',
        key: 'tags',
        slots: { customRender: 'tags' },
        width: 100,
        ellipsis: true
      },
      {
        title: '关联教材',
        dataIndex: 'book.name',
        key: 'book.name',
        ellipsis: true,
        width: 80
      },
      {
        title: '教材出版社',
        dataIndex: 'book.press_version.name',
        ellipsis: true,
        width: 80
      },
      {
        title: '关联教材章节',
        dataIndex: 'section.name',
        key: 'book.name',
        ellipsis: true,
        width: 80
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 80,
        slots: { customRender: 'actions' }
      }
    ]

    return {
      visibleValue,
      tabSet,
      dataList,
      currentTabKey,
      cloumns,
      paginations,
      formData,
      tagOpts,
      loading,
      bookShowName,
      bookModalRef,
      bookModalVisible,
      handleBookSelectOk,
      handleShowBookModal,
      getTagSearch,
      handleSearch,
      handleSearchBtnClick,
      handleResetForm,
      handleAddSong,
      handleCancel,
      queryOfficialList
    }
  }
}
